import { SvgIcon } from "@mui/material";
import { InfoFilledIcon } from "../../../assets/customIcons";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import { store } from "../../../store/store";
import { UnitOfMeasurementList } from "../../jobCardDetails/services/apiCalls";
import StockAvailability from "./stockAvailability";
var dispatch = store.dispatch;
export var spareIssuePartElements = [{
        type: FormItemTypes.ContainerItem,
        name: '',
        padding: '10px',
        rowSpacing: 2,
        columnSpacing: 2,
        elements: [{
                type: FormItemTypes.TextInput,
                name: 'LocationDetailsName',
                label: 'Location Details',
                xs: 12,
                disabled: true,
                valueGetter: function (formValues, field) {
                    var _formValues$LocationD, _formValues$LocationD2;
                    // console.log("formValues",formValues)
                    return (_formValues$LocationD = formValues === null || formValues === void 0 || (_formValues$LocationD2 = formValues.LocationDetails) === null || _formValues$LocationD2 === void 0 || (_formValues$LocationD2 = _formValues$LocationD2[0]) === null || _formValues$LocationD2 === void 0 ? void 0 : _formValues$LocationD2.LocationName) !== null && _formValues$LocationD !== void 0 ? _formValues$LocationD : '';
                }
            }, {
                type: FormItemTypes.NumberInput,
                name: 'RequestedQuantity',
                label: 'Requested Qty',
                xs: 6,
                disabled: true
                // valueGetter(formValues, field) {
                //     return formValues?.Quantity ?? 0
                // },
            }, {
                type: FormItemTypes.SearchSelect,
                name: 'UnitOfMeasurementId',
                label: 'UOM',
                xs: 6,
                getListData: UnitOfMeasurementList,
                apiKey: 'UnitOfMeasurementList',
                // getOptionLabel: (option: any) => option?.Name,
                valueSetter: function (row, value) { return ({
                    UnitOfMeasurementName: value === null || value === void 0 ? void 0 : value.Name,
                    UnitOfMeasurementId: value === null || value === void 0 ? void 0 : value.id
                }); }
            }, {
                type: FormItemTypes.Box,
                name: '',
                columnSize: 6,
                elements: [{
                        type: FormItemTypes.Box,
                        name: '',
                        display: 'flex',
                        justifyContent: 'space-between',
                        columnSize: 12,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: '',
                                children: 'Available Qty.',
                                columnSize: 0,
                                fontSize: 'sm',
                                color: 'text.secondary',
                                fontWeight: 'medium'
                            }, {
                                type: FormItemTypes.IconButton,
                                name: 'icon',
                                children: /*#__PURE__*/ React.createElement(SvgIcon, {
                                    color: "primary",
                                    sx: {
                                        height: 20,
                                        width: 20
                                    }
                                }, /*#__PURE__*/ React.createElement(InfoFilledIcon, null), ","),
                                columnSize: 0,
                                onClick: function (e, state) {
                                    dispatch(showSurface({
                                        type: 'Drawer',
                                        Component: StockAvailability,
                                        containerProps: {
                                            PaperProps: {
                                                sx: {
                                                    px: 0.5,
                                                    width: {
                                                        xs: '100%'
                                                    },
                                                    borderRadius: '8px 8px 0 0'
                                                }
                                            },
                                            anchor: 'bottom'
                                        },
                                        componentProps: {
                                            data: state
                                        }
                                    }));
                                }
                            }]
                    }, {
                        type: FormItemTypes.NumberInput,
                        name: 'AvailableQuantity',
                        label: '',
                        columnSize: 0,
                        disabled: true,
                        sx: {
                            p: 0
                        }
                        // valueGetter(formValues, field) {
                        //     return formValues?.AvailableQuantity ?? 0
                        // },
                    }]
            }, {
                type: FormItemTypes.NumberInput,
                name: 'IssuedQuantity',
                label: 'Issued Qty',
                value: null,
                xs: 6,
                disabled: true
            }, {
                type: FormItemTypes.NumberInput,
                name: 'IssueQuantity',
                label: 'Issue Qty',
                value: null,
                xs: 12,
                validator: function (value, state) {
                    var _state$RequestedQuant, _state$AvailableQuant;
                    var updatedReqQty = (state === null || state === void 0 ? void 0 : state.RequestedQuantity) - (state === null || state === void 0 ? void 0 : state.IssuedQuantity);
                    if (value < 1) {
                        return 'Issue quantity must not be less than 1';
                    }
                    else if (value > ((_state$RequestedQuant = state === null || state === void 0 ? void 0 : state.RequestedQuantity) !== null && _state$RequestedQuant !== void 0 ? _state$RequestedQuant : 0)) {
                        return 'Issue quantity cannot be more than requested quantity.';
                    }
                    else if (value > ((_state$AvailableQuant = state === null || state === void 0 ? void 0 : state.AvailableQuantity) !== null && _state$AvailableQuant !== void 0 ? _state$AvailableQuant : 0)) {
                        return 'Available stock is lesser than issue quantity.';
                    }
                    else if (value > updatedReqQty)
                        return 'Issue quantity cannot be more than pending quantity';
                    else {
                        return '';
                    }
                }
            }, {
                type: FormItemTypes.NumberInput,
                name: 'PendingQuantity',
                label: 'Pending Qty',
                value: null,
                xs: 12,
                disabled: true
            }, {
                type: FormItemTypes.NumberInput,
                name: 'SerialNumber',
                label: 'Serial Number',
                xs: 12,
                disabled: true
            }],
        columnSize: 12
    }];
